<template>
  <vue-markdown class="content-text" :source="text" :options="markdownOptions()" :plugins="plugins"></vue-markdown>
</template>

<script setup>
import VueMarkdownSup from 'markdown-it-sup'
const plugins = [VueMarkdownSup]
</script>

<script>
import VueMarkdown from "vue-markdown-render";
import {generateMarkdownOptions} from "@/common-functions";

export default {
  components: {VueMarkdown},
  props: [
      "text"
  ],
  data() {
    return {
    };
  },
  methods: {
    markdownOptions() {
      return generateMarkdownOptions();
    }
  }
}
</script>

<style scoped>
.content-text {
  overflow-y: visible;
}
</style>
